module.exports = __webpack_public_path__ + "img/selectedBg.a6a16543.svg";